import {UPDATE_SEARCH_BAR} from "../constants/Search";

export const updateSearchBar = (placeholder, showSearch, searchFunction) => {
  return {
    type: UPDATE_SEARCH_BAR,
    placeholder,
    showSearch,
    searchFunction,
  }
}